module.exports = __webpack_public_path__ + "static/media/alert-dark.ecf1eae0.svg";